var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--border2",class:{
        coolGrey: !_vm.value,
        'coolGrey-solid-shadow': !_vm.value,
        secondary: _vm.value,
        'secondary-solid-shadow': _vm.value,
    },staticStyle:{"width":"24px","height":"24px"},attrs:{"flat":"","small":"","fab":"","color":"coolGrey"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"size":"16","color":"white"}},[_vm._v("check")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }